import { bootstrapLoader } from './loader';

function registerServiceWorker(): void {
  try {
    if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
      return;
    }

    const isSecureContext = window.location.protocol === 'https:';
    const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

    if (!isSecureContext && !isLocalhost) {
      return;
    }

    const swUrl = new URL('sw.js', window.location.href).toString();

    navigator.serviceWorker
      .register(swUrl, { scope: './' })
      .catch(function (error) {
        console.warn('Service worker registration failed', error);
      });
  } catch (error) {
    console.warn('Service worker setup error', error);
  }
}

document.addEventListener('DOMContentLoaded', function () {
  registerServiceWorker();
  bootstrapLoader();
});
